import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { Task } from '../../../types/Task';
import { mutationKeys } from '../mutationKeys';

export const updateTask = async (uuid: string | undefined, formData: Task) => {
  if (!uuid) return null;

  const response = await CustomAxios.put(`tasks/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdateTaskFormProps {
  uuid?: string;
  onSuccessCallback: () => void;
}
export function useUpdateTask({ uuid, onSuccessCallback }: UseUpdateTaskFormProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateTask],
    mutationFn: (formData: Task) => updateTask(uuid, formData),
    onSuccess: (data: Task) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTasks, data.uuid] });

      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const task: Task = err.response.data as Task;
        queryClient.setQueryData([queryKeys.allTasks, task.uuid], task);
      }
    },
  });
}
